import { render, staticRenderFns } from "./RepliedFilter.vue?vue&type=template&id=45120a0e&scoped=true&"
import script from "./RepliedFilter.vue?vue&type=script&lang=js&"
export * from "./RepliedFilter.vue?vue&type=script&lang=js&"
import style0 from "./RepliedFilter.vue?vue&type=style&index=0&id=45120a0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45120a0e",
  null
  
)

export default component.exports